<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>


        <div class="container-fluid mt--7">
            <div class="row">

                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase">My Applications</h3>
                                </div>
                                <!-- <div class="col-4 text-right">
                                    <a href="#!" class="btn btn-sm btn-primary">Settings</a>
                                </div> -->
                            </div>
                        </div>

                        <template>
                            <tabs fill class="flex-column flex-md-row">
                                <card shadow>
                                    <tab-pane title="Previous Applications">
                                        <span slot="title">
                                            <i class="ni ni-books"></i>
                                            Previous Applications
                                        </span>
                                        <!-- import User Previous Applications template here -->
                                        <PreviousApplications />
                                    </tab-pane>

                                    <tab-pane 
                                        title="New Applications"
                                        @tab-activated="triggerNewApplications"
                                    >
                                        <span slot="title">
                                            <i class="ni ni-collection"></i>
                                            New Applications
                                        </span>
                                        <!-- import User New Applications template here -->
                                        <NewApplications 
                                            ref="callNewApplications" 
                                        />
                                    </tab-pane>
                                </card>
                            </tabs>

                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import PreviousApplications from './PreviousApplications.vue';
    import NewApplications from './NewApplications.vue';

    export default {
        components: {
            PreviousApplications,
            NewApplications
        },
        name: 'Applications',
        methods: {
            triggerNewApplications() {
                if (this.$refs.callNewApplications && this.$refs.callNewApplications.loadNewApplications) {
                    this.$refs.callNewApplications.loadNewApplications();
                }
            }
        }
    };
</script>
<style scoped>
    .width600 {
        width: 600px !important;
    }
    .marginLeft23 {
        margin-left: 23px;
    }
    .image-size {
        height: 180px;
        width: 190px;
    }
</style>
